import { createAction, createRequestTypes, REQUEST, SUCCESS, FAILURE } from '../../../utils/actionGenerator';

export const ADD_CS_AGENT = createRequestTypes('ADD_CS_AGENT');
export const RESET_TICKET_ASSIGNMENT = 'RESET_TICKET_ASSIGNMENT';
export const SUPPORT_AGENT_UPDATE = createRequestTypes('SUPPORT_AGENT_UPDATE');
export const GET_SUPPORT_AGENT_TEAMS = createRequestTypes('GET_SUPPORT_AGENT_TEAMS');
export const SET_TICKET_ASSIGNMENT_SELECTED_TEAM = 'SET_TICKET_ASSIGNMENT_SELECTED_TEAM';
export const GET_TICKET_ASSIGNMENT_DATA = createRequestTypes('GET_TICKET_ASSIGNMENT_DATA');

export const getSupportAgentTeams = {
  request: () => createAction(GET_SUPPORT_AGENT_TEAMS[REQUEST]),
  success: (response) => createAction(GET_SUPPORT_AGENT_TEAMS[SUCCESS], { response }),
  failure: (response) => createAction(GET_SUPPORT_AGENT_TEAMS[FAILURE], { response }),
};

export const setTicketAssignmentSelectedTeam = (team) => ({
  type: SET_TICKET_ASSIGNMENT_SELECTED_TEAM,
  team,
});

export const getTicketAssignmentData = {
  request: (params) => createAction(GET_TICKET_ASSIGNMENT_DATA[REQUEST], { params }),
  success: (response) => createAction(GET_TICKET_ASSIGNMENT_DATA[SUCCESS], { response }),
  failure: (response) => createAction(GET_TICKET_ASSIGNMENT_DATA[FAILURE], { response }),
};

export const addCsAgent = {
  request: (payload) => createAction(ADD_CS_AGENT[REQUEST], { payload }),
  success: (response) => createAction(ADD_CS_AGENT[SUCCESS], { response }),
  failure: (response) => createAction(ADD_CS_AGENT[FAILURE], { response }),
};

export const supportAgentUpdate = {
  request: (payload) => createAction(SUPPORT_AGENT_UPDATE[REQUEST], { payload }),
  success: (response) => createAction(SUPPORT_AGENT_UPDATE[SUCCESS], { response }),
  failure: (response) => createAction(SUPPORT_AGENT_UPDATE[FAILURE], { response }),
};

export const resetTicketAssignment = () => ({
  type: RESET_TICKET_ASSIGNMENT,
});
